import { singletonObj } from '@livelybone/singleton';
import localforage from 'localforage';
import { isNullLike, jsonSafeParse } from '@/utils/fns';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class UserStorage {
  constructor(key, uidGetter) {
    this.key = key;
    this.uidGetter = uidGetter;
  }
  get() {
    const whole = jsonSafeParse(localStorage.getItem(this.key), {});
    const uid = this.uidGetter();
    return whole?.[uid];
  }
  set(val) {
    const whole = jsonSafeParse(localStorage.getItem(this.key), {}) || {};
    const uid = this.uidGetter();
    if (!isNullLike(val)) whole[uid] = val;else delete whole[uid];
    return localStorage.setItem(this.key, JSON.stringify(whole));
  }
  remove() {
    this.set(null);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class UserLocalforage {
  static get storage() {
    return singletonObj('user_storage_localforage', () => localforage.createInstance({
      driver: localforage.INDEXEDDB,
      name: 'user_storage',
      storeName: 'key_value_pairs',
      version: 1
    }));
  }
  constructor(key, uidGetter) {
    this.key = key;
    this.uidGetter = uidGetter;
  }
  get() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return UserLocalforage.storage.getItem(this.key).then(wholeJson => {
      const whole = typeof wholeJson === 'string' ? jsonSafeParse(wholeJson, {}) : wholeJson;
      const uid = this.uidGetter();
      return whole?.[uid];
    });
  }
  set(val) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return UserLocalforage.storage.getItem(this.key).then(wholeJson => {
      const whole = typeof wholeJson === 'string' ? jsonSafeParse(wholeJson, {}) : wholeJson;
      const uid = this.uidGetter();
      if (!isNullLike(val)) whole[uid] = val;else delete whole[uid];
      return UserLocalforage.storage.setItem(this.key, JSON.stringify(whole));
    });
  }
  remove() {
    return this.set(null);
  }
}
export const LocalUser = {
  setter: val => val ? localStorage.setItem('user', JSON.stringify(val)) : localStorage.removeItem('user'),
  getter: () => jsonSafeParse(localStorage.getItem('user'), undefined)
};
export const AuthToken = new UserStorage('auth-token', () => 'cur');
export const AuthTokenRefreshTime = new UserStorage('auth-token-refresh-time', () => 'cur');
export const PartnerInfo = new UserStorage('partnerInfo', () => 'cur');